"use client";

import { ReactNode } from "react";
import {
  CrossmintProvider,
  CrossmintAuthProvider,
  CrossmintWalletProvider,
} from "@crossmint/client-sdk-react-ui";

interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  const clientKey = import.meta.env.VITE_CROSSMINT_CLIENTKEY;

  if (!clientKey) {
    throw new Error(
      "Crossmint client key is not defined. Please set VITE_CROSSMINT_CLIENTKEY in your environment variables."
    );
  }

  return (
    <CrossmintProvider apiKey={clientKey}>
      <CrossmintAuthProvider
        authModalTitle="Sign in to CashTap"
        termsOfServiceText={
          <p className="text-gray-400 text-sm">
            By continuing, you agree to our{" "}
            <a href="/terms-of-use" className="text-[#61CE70] hover:underline">
              Terms of Use
            </a>{" "}
            and{" "}
            <a href="/privacy-policy" className="text-[#61CE70] hover:underline">
              Privacy Policy
            </a>
          </p>
        }
        appearance={{
          spacingUnit: "8px",
          borderRadius: "16px",
          colors: {
            background: "#0F1419",
            backgroundSecondary: "#1A1F2B", // slightly lighter dark surface
            backgroundTertiary: "#252B38",
            inputBackground: "#1A1F2B",
            buttonBackground: "#1A1F2B",
            border: "#374151",
            textPrimary: "#F9FAFB",
            textSecondary: "#9CA3AF",
            textLink: "#61CE70",
            accent: "#61CE70",
            danger: "#EF4444",
          },
          hideCardForm:true,
        }}
        loginMethods={["email", "google", "twitter", "farcaster"]}
      >
        <CrossmintWalletProvider
          createOnLogin={{
            chain: "base",
            signer: {
              type: "email",
            },
          }}
        >
          {children}
        </CrossmintWalletProvider>
      </CrossmintAuthProvider>
    </CrossmintProvider>
  );
}
